export const UnpaidData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 4,
  leavecategoryid: 1,
  leavename: null,
  description: null,
  maxleave: 1,
  maxleavedurationtypeid: 0,
  maxconsecutiveleave: 1,
  maxconsecutiveleavedurationtypeid: 0,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 0,
  notifynotbeforeday: 0,
  ispastappallowed: false,
  apppastday: 0,
  isintervinigallowed: false,
  interviningpolicy: {
    isinterviningholiday: false,
    holidayinterviningcount: 0,
    isholidayinterviningclubbed: false,
    isprefixholiday: false,
    holidayprefixcount: 0,
    issuffixholiday: false,
    holidaysuffixcount: 0,
    isinterviningoptholiday: false,
    optholidayinterviningcount: 0,
    isoptholidayinterviningclubbed: false,
    isprefixoptholiday: false,
    optholidayprefixcount: 0,
    issuffixoptholiday: false,
    optholidaysuffixcount: 0,
    isinterviningweeklyoff: false,
    weeklyoffinterviningcount: 0,
    isweeklyoffinterviningclubbed: false,
    isprefixweeklyoff: false,
    weeklyoffprefixcount: 0,
    issuffixweeklyoff: false,
    weeklyoffsuffixcount: 0,
  },
  isclubbingallowed: false,
  clubbingleaveid: null,
  datastate: 1,
};
